<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="addRechargeClick" v-if="auth_control.have_add_auth">新增充值赠送</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="recharge_money"
		      label="充值金额(元)"
		      align="center"
        >
		    </el-table-column>

		    <el-table-column
		      prop="recharge_amount"
		      label="赠送金额(元)"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="160"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editRechargeClick(scope.row)" v-if="auth_control.have_edit_auth">编辑</span>
         	    <span class="opration-item" @click="deleteRechargeClick(scope.row)" v-if="auth_control.have_delete_auth">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
    </div>
    <common-dialog
    :title="dialogTitle"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		  <div v-if="dialogType === 'add' || dialogType === 'edit'">
  		  	<div class="input-wrap">
						<label for="recharge_money">充值金额:</label>
						<el-input
						  type="number"
						  v-model="rechargeInfo.recharge_money"
						  placeholder="请输入充值金额（元）"
						  id="recharge_money"
						  class="recharge_money_input"
						></el-input>
					</div>
					<div class="input-wrap">
						<label for="recharge_amount">赠送金额:</label>
						<el-input
						  type="number"
						  v-model="rechargeInfo.recharge_amount"
						  placeholder="请输入赠送金额（元）"
						  id="recharge_amount"
						  class="recharge_amount_input"
						></el-input>
					</div>
  		  </div>
  		  <div v-if="dialogType === 'delete'">
  		  	是否删除该充值赠送？
  		  </div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import CommonDialog from '@/components/CommonDialog';
import { rechargeList, addRecharge, editRecharge, deleteRecharge } from '@/api/recharge-manage';
import { mapState } from 'vuex';

export default {
  name: 'messagepush',
  data() {
  	return {
      dialogVisible: false,
      tableData: [],
  		handle_row: {},
  		dialogTitle: '',
  		dialogType: '',
  		rechargeInfo: {},
      auth_control: {
        have_add_auth: false,
        have_edit_auth: false,
        have_delete_auth: false,
      },
      three_rules: [],
  	}
  },
  components: {
  	CommonDialog
  },
  computed: {
    ...mapState(['operationList'])
  },
  mounted() {
    this.getRechargeList();
    this.handleThreeRules();
  },
  methods: {
  	async getRechargeList() {
      const { status, data } = await rechargeList();
      if ( status !== 200 ) return
      this.tableData = data;
  	},
  	dialogCancelClick() {
      this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
      switch (this.dialogType) {
      	case 'add':
          const { recharge_money, recharge_amount } =this.rechargeInfo;
      	  if (!recharge_money) {
      	  	this.$message('充值金额不能为空');
      	  	break
          }
          if (+recharge_money <  0 || +recharge_amount < 0) {
            this.$message('充值金额和赠送金额不能为负数');
      	  	break
          }
      	  const { status } = await addRecharge(this.rechargeInfo);
      	  if ( status === 200) {
      	    this.dialogVisible = false;
          }
          break
        case 'edit':
          {
            const { recharge_money, recharge_amount } =this.rechargeInfo;
	          if (!recharge_money) {
	      	  	this.$message('充值金额不能为空');
	      	  	break
            }
            if (+recharge_money <  0 || +recharge_amount < 0) {
              this.$message('充值金额和赠送金额不能为负数');
              break
            }
	      	  const { status } = await editRecharge(this.rechargeInfo);
	      	  if ( status === 200) {
	      	    this.dialogVisible = false;
            }
            break;
	        }
	      case 'delete': 
	        {
	        	const { status } = await deleteRecharge(this.rechargeInfo.uuid);
	        	if (status === 200) {
	        		this.dialogVisible = false;
	        		break;
	        	}
	        }
      }
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this.rechargeInfo = {};
      this.getRechargeList();
  	},
  	addRechargeClick() {
      this.dialogType = 'add';
      this.dialogTitle = '新增充值赠送';
      this.dialogVisible = true;
  	},
  	editRechargeClick(row) {
  		this.rechargeInfo= JSON.parse(JSON.stringify(row));
  		this.dialogType = 'edit';
  		this.dialogTitle = '编辑充值赠送';
  		this.dialogVisible = true;
  	},
  	deleteRechargeClick(row) {
  		this.rechargeInfo= JSON.parse(JSON.stringify(row));
  		this.dialogType = 'delete';
  		this.dialogTitle = '删除充值赠送';
  		this.dialogVisible = true;
  	},
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf('新增') !== -1:
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf('删除') !== -1:
            this.auth_control.have_delete_auth = true;
            break;
          case item.menu_name.indexOf('编辑') !== -1:
            this.auth_control.have_edit_auth = true;
            break;
        }
      })
     console.log(this.three_rules, 'three rules recharge')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.addBtn {
	float: right;
	margin-bottom: 30px;
}
.table-wrap {
	margin-top: 30px;
	.operation-wrap {
		display: flex;
		justify-content: space-around;
		color: @color-text;
		.opration-item {
			cursor: pointer;
		}
	}
}
.dialog-body-wrap {
	text-align: center;
	.input-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
		label {
			margin-right: 30px;
		}
		.recharge_money_input, .recharge_amount_input {
			width: 194px;
		}
	}
}
</style>
